var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.imageUrl
      ? _c(
          "div",
          {
            staticClass: "w-full relative overflow-hidden",
            style: { backgroundColor: _vm.backgroundColor }
          },
          [
            _c("img", {
              directives: [
                {
                  name: "lazy",
                  rawName: "v-lazy",
                  value: _vm.imageUrl,
                  expression: "imageUrl"
                }
              ],
              staticClass: "opacity-100 mx-auto",
              attrs: { alt: "Collection Banner" }
            })
          ]
        )
      : _vm._e(),
    _c("div", { staticClass: "py-2 bg-brand-secondary-50" }, [
      _c("div", { staticClass: "container mx-auto px-1" }, [
        _c("div", { staticClass: "text-3xl font-bold" }, [
          _vm._v(_vm._s(_vm.info.name))
        ]),
        _c("div", {
          staticClass:
            "mt-1 text-brand-secondary-850 leading-tight collection__description",
          domProps: { innerHTML: _vm._s(_vm.info.description) }
        })
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }